import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const LineChart = ({ report, metric = 'kvart' }) => {
  // Format time and extract values
  const  [data,setData]=useState()
  console.log(report)
       const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  // const timeLabels = data.map(d => dayjs(d.createdon).format('HH:mm'));
  // const values = data.map(d => d[metric]);
function prepareEChartLineData(inputData) {
  if (!Array.isArray(inputData)) return { xAxisData: [], seriesChartData: [] };

  const xAxisSet = new Set();
  const seriesMap = new Map(); // Key: 'METERNAME-Parameter'

  inputData.forEach((item) => {
    const dateStr = item.CreatedON.replace("T"," "); // Assume this is in valid ISO or expected format
    if (!dateStr) return;

    xAxisSet.add(dateStr);

    Object.keys(item).forEach((key) => {
      if (["CreatedON", "METERNAME", "METERID", "SITENAME","FromDate","Todate","createdON","fromdate","todate","sitename","meterid"].includes(key)) return;

      const seriesKey = `${item.METERNAME}-${key}`;
      if (!seriesMap.has(seriesKey)) {
        seriesMap.set(seriesKey, new Map());
      }
      seriesMap.get(seriesKey).set(dateStr, item[key]);
    });
  });

  // Convert to array and sort using Date object
  const xAxisData = Array.from(xAxisSet).sort((a, b) => new Date(a) - new Date(b));

  const seriesChartData = [];
  for (let [name, timeMap] of seriesMap.entries()) {
    const data = xAxisData.map((t) => timeMap.get(t) ?? null); // fill missing with null
    seriesChartData.push({
      name,
      type: "line",
      smooth: true,
      data,
    });
  }

  return { xAxisData, seriesChartData };
}



  const { xAxisData, seriesChartData } = prepareEChartLineData(report);
  //console.log(xAxisData)
  //console.log(xAxisData)
  //console.log(seriesChartData)
const option = {
  // title: {
  //   // text: `Meter Data  Line Chart`,
  //   left: 'center',
  //   top:'0px',
  //   // bottom:'20px'
  // },
  tooltip: {
    trigger: 'axis',
  },
   legend: {
    textStyle: {
      color: isdarkMode ? 'white' : 'black'   // Set the legend text color here
    },
  type: 'scroll',
  top: '0%',
  orient: 'horizontal',
  left: 'center',   // Centers the legend
  itemGap: 10,      // Adjust spacing between items
  padding: [5, 20], // Optional padding
  width: '80%'      // Prevents it from taking full width
},
dataZoom: [
  // Horizontal zoom (bottom slider)
  {
    type: "slider",
    show: true,
    xAxisIndex: 0,
    start: 0,
    end: 100,
  },
  // Horizontal zoom (drag inside)
  {
    type: "inside",
    xAxisIndex: 0,
    start: 0,
    end: 100,
  },
  // ✅ Vertical zoom (right slider)
  {
    type: "slider",
    show: true,
    yAxisIndex: 0,
    start: 0,
    end: 100,
    right: 10, // optional: position slider from right
    width: 15, // optional: slider thickness
    orient: "vertical", // vertical orientation
  },
  // Vertical zoom (drag inside)
  {
    type: "inside",
    yAxisIndex: 0,
    start: 0,
    end: 100,
  },
],
  xAxis: {
    type: 'category',
    data: xAxisData,
    axisLabel: {
      rotate: 45,
      color: isdarkMode ? 'white' : 'black'   // X axis label color
    },
    axisLine: {
      lineStyle: {
        color: isdarkMode ? 'white' : 'black' // X axis line color
      }
    }
  },
  yAxis: {
    type: 'value',
    name: 'Value',
    axisLabel: {
      color: isdarkMode ? 'white' : 'black'   // Y axis label color
    },
    axisLine: {
      lineStyle: {
        color: isdarkMode ? 'white' : 'black' // Y axis line color
      }
    }
  },
  series: seriesChartData,
  grid: {
    left: '10%',
    right: '10%',
    bottom: '20%',
    
  },
};

  return (
  <div className='border rounded-xl p-2 py-4'>
  <ReactECharts option={option} style={{ height: 600 }} />;
  </div>
  )
};

export default LineChart;
